import {
  GET_REUSEABLE_LIST,
  GET_REUSEABLE_LIST_FAIL,
  GET_REUSEABLE_LIST_SUCCESS,
  GET_REUSEABLE_DETAILS,
  GET_REUSEABLE_DETAILS_FAIL,
  GET_REUSEABLE_DETAILS_SUCCESS,
  ADD_NEW_REUSEABLE,
  ADD_REUSEABLE_SETTING_SUCCESS,
  ADD_REUSEABLE_SETTING_FAIL,
  UPDATE_REUSEABLE,
  UPDATE_REUSEABLE_SUCCESS,
  UPDATE_REUSEABLE_FAIL,
  DELETE_REUSEABLE,
  DELETE_REUSEABLE_SUCCESS,
  DELETE_REUSEABLE_FAIL,
  EXPORT_REUSEABLE_EXCEL,
  EXPORT_REUSEABLE_EXCEL_SUCCESS,
  EXPORT_REUSEABLE_EXCEL_FAIL,
  RESET_REUSEABLE_SETTING_STATE,
  RESET_REUSEABLE_SETTING_ACTION_STATE,
} from "./actionTypes";

export const getReuseableListing = ({ api, reuseable }) => {
  return {
    type: GET_REUSEABLE_LIST,
    payload: { api, reuseable },
  };
};


export const getReuseableListingSuccess = reuseable => ({
  type: GET_REUSEABLE_LIST_SUCCESS,
  payload: reuseable,
});

export const getReuseableListingFail = error => ({
  type: GET_REUSEABLE_LIST_FAIL,
  payload: error,
});

export const getReuseableDetails = ({api, id}) => ({
  type: GET_REUSEABLE_DETAILS,
  payload: {api, id},
});

export const getReuseableDetailsSuccess = reuseable => ({
  type: GET_REUSEABLE_DETAILS_SUCCESS,
  payload: reuseable,
});

export const getReuseableDetailsFail = error => ({
  type: GET_REUSEABLE_DETAILS_FAIL,
  payload: error,
});

//add 
export const addNewReuseable = ({api, reuseable, value }) => ({
  type: ADD_NEW_REUSEABLE,
  payload: {api, reuseable, value},
});

export const addReuseableSettingSuccess = reuseable => ({
  type: ADD_REUSEABLE_SETTING_SUCCESS,
  payload: reuseable,
});

export const addReuseableSettingFail = error => ({
  type: ADD_REUSEABLE_SETTING_FAIL,
  payload: error,
});

//update 
export const updateReuseable =({api, id, reuseable}) => ({
  type: UPDATE_REUSEABLE,
  payload:{api, id, reuseable},
});

export const updateReuseableSuccess = reuseable => ({
  type: UPDATE_REUSEABLE_SUCCESS,
  payload: reuseable,
});

export const updateReuseableFail = error => ({
  type: UPDATE_REUSEABLE_FAIL,
  payload: error,
});

//delete 
export const deleteReuseable =({api, id}) => ({
  type: DELETE_REUSEABLE,
  payload:{api, id},
});

export const deleteReuseableSuccess = reuseable => ({
  type: DELETE_REUSEABLE_SUCCESS,
  payload: reuseable,
});

export const deleteReuseableFail = error => ({
  type: DELETE_REUSEABLE_FAIL,
  payload: error,
});

//exprt excel
export const exportReuseableExcel = ({api, reuseable}) => ({
  type: EXPORT_REUSEABLE_EXCEL,
  payload: {api, reuseable},
});

export const exportReuseableExcelSuccess = reuseable => ({
  type: EXPORT_REUSEABLE_EXCEL_SUCCESS,
  payload: reuseable,
});

export const exportReuseableExcelFail = error => ({
  type: EXPORT_REUSEABLE_EXCEL_FAIL,
  payload: error,
});



//reset
export const resetReuseableSettingState = (api) => {
  return {
      type: RESET_REUSEABLE_SETTING_STATE,
  }
}

//reset attachment
export const resetReuseableSettingActionState = () => {
  return {
      type: RESET_REUSEABLE_SETTING_ACTION_STATE,
  }
}

